var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlipFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74322 4.03101V1.01562H7.1063V3.24486L5.72784 4.54793L3.40168 5.32332L2.10938 7.90793V10.4925H3.70322V8.3387L4.29553 7.15409L5.01707 8.24178L6.22322 10.0618H9.43245L12.4478 12.6464L13.5678 11.3541L9.86322 8.3387H8.60322V8.31716L10.294 6.61562H14.1709V4.9787H9.73399L7.90322 6.66947L7.03091 5.61409L8.75399 4.02024L8.74322 4.03101ZM5.95399 3.0187C5.95399 3.89101 5.25399 4.59101 4.38168 4.59101C3.50938 4.59101 2.80937 3.89101 2.80937 3.0187C2.80937 2.14639 3.50938 1.44639 4.38168 1.44639C5.25399 1.44639 5.95399 2.14639 5.95399 3.0187Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.207H1V14.8224H15V13.207Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlipFall);
export default __webpack_public_path__ + "static/media/icon-slip-fall.45d891c6a840f8db71794f40a7da67bb.svg";
export { ForwardRef as ReactComponent };